<template>
  <div>
    <OrganisationTable
      :canEdit="true"
      editRoute="SuperAdminClinicEdit"
      :canCreate="true"
      createRoute="SuperAdminClinicCreate"
      :canAssignClinic="false"
    />
  </div>
</template>

<script>
import OrganisationTable from '../../components/organization/organizationTable.vue';

export default {
  components: {
    OrganisationTable,
  },
  data: () => ({}),
};
</script>
